import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {CdCommonModule} from '../cd-common/cd-common.module';
import {AutoSaveStatusComponent} from './auto-save-status/auto-save-status.component';
import {LanguageSwitchComponent} from './language-switch/language-switch.component';
import {CdNotificationComponent} from './notification/cd-notification.component';
import {UserDropdownComponent} from './user-dropdown/user-dropdown.component';
import {CdWebsocketStatusComponent} from './websocket-status/cd-websocket-status.component';

@NgModule({
  imports: [
    CommonModule,
    // CdCommonModule must come after CommonModule because of the overriden Datepipe in CdCommonModule
    CdCommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    AutoSaveStatusComponent,
    CdNotificationComponent,
    CdWebsocketStatusComponent,
    LanguageSwitchComponent,
    UserDropdownComponent
  ],
  exports: []
})
export class ViewModule {}
